<div class="py-4 px-6">
  <div class="d-flex justify-content-between mb-3">
    <h5 class="modal-title pull-left semibold">{{ title | translate }}</h5>
    <button type="button" class="btn btn-icon" aria-label="Close" (click)="onClose()">
      <i class="icon-close icon-16"></i>
    </button>
  </div>

  <p *ngFor="let message of messages" class="note">{{ message | translate }}</p>

  <div class="d-flex justify-content-end pb-2 pt-5">
    <button type="button" class="btn btn-light mx-2" (click)="onClose()">
      {{ cancelButton | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="onAction()">
      {{ confirmButton | translate }}
    </button>
  </div>
</div>
